<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.physicalExams', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group
                            id="exams-group"
                            :label="$tc('message.physicalExams', 1)"
                            label-for="exams"
                    >
                        <b-form-select
                                id="exams"
                                v-model="$v.form.exams.$model"
                                :state="$v.form.exams.$dirty ? !$v.form.exams.$error : null"
                                :options="mPhysicals"
                                required
                                multiple
                        ></b-form-select>

                        <b-form-invalid-feedback>
                            {{ $t('message.requiredField') }}
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" variant="primary">
                        {{ $t('message.add') }}
                    </b-button>

<!--                    <b-button type="reset" variant="danger">-->
<!--                        {{ $t('message.reset') }}-->
<!--                    </b-button>-->
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';

    export default {
        name: "AddPhysicalExam",

        computed: {
            ...mapGetters(["physicalExams"]),

            mPhysicals: function() {
                let eArray = [];

                _.forEach(this.physicalExams, function(exam) {
                    let e = { text: exam.reference, value: exam.id };

                    eArray.push(e);
                });

                return eArray;
            }
        },

        data() {
            return {
                form: {
                    exams: [],
                },
                show: true
            }
        },

        methods: {
            getPhysicalExams() {
                let args = {};

                this.$store.dispatch('getPhysicalExams', { args : args });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        examensClinique: this.form.exams
                    };

                    let successMessage = this.$i18n.t('message.physicalExamCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createConsultationPhysicalExams', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.exams = [];

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            }
        },

        validations: {
            form: {
                exams: {
                    required
                }
            }
        },

        mounted() {
            // Fetch physical exam list
            this.getPhysicalExams();
        }
    }
</script>

<style scoped>

</style>